
import { TextButton } from "Components/Button";
import DynamicFormPopup from "Components/Popup/DynamicFormPopup";
import Tag from "Components/Tag/Tag";
import { Card, Col, Stack } from "react-bootstrap";
import { ICONS } from "Utils/icons";
import { useState, useEffect,useReducer } from "react";

const Event = ({name, tags, description, date, buttons}) => {

    

    return (
        <Col lg={4} className="event-col d-flex justify-content-center">
            <Card className="h-100 event">
                <Card.Body className="p-0">
                    <h3 className="name text-start">{name}</h3>
                    <div className="tag-container d-flex column-gap-2">
                        {tags.map((tag)=> {
                            if(tag.text!=null & tag.text!=""){
                                return <Tag text={tag.text} icon={tag.icon}></Tag>;
                            }
                            else {
                                return null;
                            }
                            
                        })}

                    </div>
                    <div className="desc mt-3 mb-3 text-start">
                        <p className="mb-0">{description}</p>
                    </div>
                    <div className="date text-start">
                        <p>{date}</p>
                    </div>
                    <div className="buttons mt-4 d-flex gap-2 flex-column flex-sm-row">
                        {buttons.map((b, index) => (
                            <TextButton
                                variant={b.variant}
                                onClick={b.action}
                                content={b.text}
                                className={b.className}
                                //disabled={b.disabled}
                            >

                            </TextButton>
                        ))}
                        
                    </div>
                </Card.Body>
            </Card>
        </Col>
        /*<Col className="h-100 card">
            <div className="event h-100 flex-grow-1">
                <h3 className="name">{name}</h3>
                <div className="tag-container d-flex column-gap-2">
                    {tags.map((tag)=> {
                        if(tag.text!=null & tag.text!=""){
                            return <Tag text={tag.text} icon={tag.icon}></Tag>;
                        }
                        else {
                            return null;
                        }
                        
                    })}

                </div>
                <div className="desc mt-3 mb-3">
                    <p>{description}</p>
                </div>
                <div className="date">
                    <p>{date}</p>
                </div>
                <div className="buttons mt-4 d-flex column-gap-2">
                    {buttons.map((b, index) => (
                        <TextButton
                            variant={b.variant}
                            onClick={b.action}
                            content={b.text}
                            className={b.className}
                            //disabled={b.disabled}
                        >

                        </TextButton>
                    ))}
                    
                </div>
            </div>
        </Col>*/
    );
}

export default Event; 